import React, { useEffect, useState, useCallback } from 'react';
import { Box, Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { fetchAllReports, deleteReport, deleteAssignmentReport } from '../api/bookings';
import { Delete as DeleteIcon } from '@mui/icons-material';
import ConfirmDialog from '../components/ConfirmDialog';

//

export default function ManageReportsPage() {
  const { t } = useTranslation();
  const [reports, setReports] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, row: null });

  const load = useCallback(async () => {
    const all = await fetchAllReports();
    setReports(all.reports || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleOpenConfirm = (row) => setConfirmDialog({ open: true, row });
  const handleCloseConfirm = () => setConfirmDialog({ open: false, row: null });
  const handleConfirmDelete = async () => {
    const row = confirmDialog.row;
    if (!row) return;
    if (row.type === 'booking') {
      await deleteReport(row.id);
    } else {
      await deleteAssignmentReport(row.id);
    }
    await load();
    handleCloseConfirm();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>{t('reports.manage_reports')}</Typography>
      <Paper sx={{ p: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('general.date')}</TableCell>
              <TableCell>{t('bookings.slot')}</TableCell>
              <TableCell>{t('general.address')}</TableCell>
              <TableCell>{t('report.number_plate')}</TableCell>
              <TableCell>{t('report.comments')}</TableCell>
              <TableCell>{t('general.created_at')}</TableCell>
              <TableCell>{t('user.reporter') || 'Reporter'}</TableCell>
              <TableCell align="right">{t('reports.cancel_report')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((row) => (
              <TableRow key={`${row.type}-${row.id}`} hover>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.slot_number}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.number_plate}</TableCell>
                <TableCell>{row.comments}</TableCell>
                <TableCell>{row.created_at}</TableCell>
                <TableCell>{row.reporter_name ? `${row.reporter_name} (${row.reporter_email || ''})` : ''}</TableCell>
                <TableCell align="right">
                  <Tooltip title={t('reports.cancel_report')}>
                    <IconButton onClick={() => handleOpenConfirm(row)} size="small" color="error">
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <ConfirmDialog
        open={confirmDialog.open}
        onClose={handleCloseConfirm}
        onConfirm={handleConfirmDelete}
        title={t('reports.cancel_report')}
        children={t('reports.confirm_cancel_report_question')}
        t={t}
      />
    </Box>
  );
}


